module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 54
// module chunks = 0